<template>
  <div class="container vh-100">
    <div class="row align-items-center justify-content-center vh-100">
      <div class="card col-md-4 mt-5 bg-secondary text-light rounded">
        <div class="card-body">
          <p>Аутентификация...</p>
          <p class="text-danger">{{ error }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vuex from 'vuex'
  import VueCookie from 'vue-cookie'

  export default {
    name: 'SSO',
    data() {
      return {
        error: ''
      }
    },
    mounted() {
      let x1sso = VueCookie.get('X1_SSO')
      if (!x1sso) {
        this.error = 'Авторизация не удалась'
        setTimeout(() => { this.$router.push({name: 'Main'}) }, 10000)
      }
      else {
        this.login()
      }
    },
    methods: {
      ...Vuex.mapActions(['ssoLogin']),
      ...Vuex.mapMutations(['setToken']),
      login () {
        this.ssoLogin()
          .then(() => {
            VueCookie.set('x2-auth-state', 'authorized', { expires: '24h' })
            this.setToken('authorized')
            if (this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect)
            } else {
              this.$router.push({name: 'Main'})
            }
          })
          .catch(error => {
            this.error = error.error.message;
            setTimeout(() => {
              this.$router.push({name: 'Login'})
            }, 10000)

          });
      }
    }
  }
</script>
